package com.karyadina.ui.screens.studyPlanner.components

import androidx.compose.foundation.layout.*
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.Delete
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.karyadina.model.Subject

@Composable
fun SubjectCard(
    subject: Subject,
    progress: Float,
    onDeleteClick: (String) -> Unit // <--- Added Callback
) {
    // val progress = 0f

    ElevatedCard(Modifier.fillMaxWidth().padding(horizontal = 16.dp)) {
        Column(Modifier.fillMaxWidth().padding(16.dp)) {
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                Column(Modifier.weight(1f)) {
                    Text(subject.name, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
                    if (subject.code.isNotBlank()) {
                        Text(subject.code, style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurface.copy(0.6f))
                    }
                }
                // Wired up Delete
                IconButton(onClick = { onDeleteClick(subject.id) }) {
                    Icon(Icons.Outlined.Delete, null, tint = MaterialTheme.colorScheme.error)
                }
            }

            if (subject.targetHoursPerWeek > 0) {
                Spacer(Modifier.height(8.dp))
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween)
                {
                    Text(org.jetbrains.compose.resources.stringResource(com.karyadina.ui.theme.StudyStrings.SubjectWeeklyProgress), style = MaterialTheme.typography.labelSmall)
                    Text("${progress.toInt()}%", style = MaterialTheme.typography.labelSmall)
                }
                Spacer(Modifier.height(4.dp))
                LinearProgressIndicator(
                    progress = { (progress / 100f).coerceIn(0f, 1f) },
                    modifier = Modifier.fillMaxWidth()
                )
            }
        }
    }
}